import {css} from 'styled-components'

export const focusStyles = css`
    outline: auto 1px Highlight; /* Highlight is firefox default focus color */
    outline: auto 1px -webkit-focus-ring-color; /* -webkit-focus-ring-color is for safari and Chromium based */
`

export const ellipsisStyles = css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
